<template>
  <b-row>
    <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0"></b-col>
    <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0"></b-col>
    <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0"></b-col>
    <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0"></b-col>
    <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
      <b-button block variant="success" @click="addStaff">Crear</b-button>
    </b-col>
    <br />
    <br />
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card :header="caption">
          <b-table
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive="sm"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template slot="name" slot-scope="data">{{data.item.name}} {{data.item.last_name}}</template>
            <template slot="status" slot-scope="data">
              <b-badge :variant="getBadge(data.item.status)">{{getTextStatus(data.item.status)}}</b-badge>
            </template>
            <template slot="actions" slot-scope="data">
              <b-button
                size="sm"
                variant="success"
                class="mr-1"
                @click="editStaff(data.item.id)"
                title="Editar"
              >
                <i class="fa fa-edit"></i>
              </b-button>

              <b-button
                size="sm"
                variant="danger"
                @click="deleteStaff(data.item.id)"
                title="Eliminar"
              >
                <i class="fa fa-trash"></i>
              </b-button>
            </template>
          </b-table>
          <hr />
          <div class="row">
            <div
              class="col-sm-4"
            >Mostrando {{getRowCount(items) > (perPage * currentPage) ? perPage * currentPage : getRowCount(items)}} de {{getRowCount(items)}} registros</div>
            <div class="col-sm-8">
              <nav>
                <b-pagination
                  size="sm"
                  align="right"
                  :total-rows="getRowCount(items)"
                  :per-page="perPage"
                  v-model="currentPage"
                  prev-text="Anterior"
                  next-text="Siguiente"
                  :limit="10"
                />
              </nav>
            </div>
          </div>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "staffs",
  props: {
    caption: {
      type: String,
      default: "Funcionarios"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      items: [],
      fields: [
        { key: "name", label: "Nombre" },
        //{key: 'last_name', label: 'Apellidos'},
        { key: "identification", label: "Identificación" },

        { key: "phone", label: "Teléfono" },
        { key: "mobile", label: "Celular" },
        { key: "personal_mail", label: "E-Mail" },

        { key: "status", label: "Estado" },
        { key: "actions", label: "Opciones" }
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      successModal: false
    };
  },
  mounted() {
    this.getStaffs(items => {
      if (items) {
        this.items = items;
      }
    });
  },
  computed: {},
  methods: {
    getStaffs(callback) {
      showLoader();
      this.$http.get(`${this.$urlApi}staffs?token=${this.token}`).then(
        response => {
          callback(response.data.data);
          hideLoader();
        },
        error => {
          console.log(error);
          alert(error.body.message);
          hideLoader();
        }
      );
    },
    getRowCount(items) {
      return items.length;
    },
    getBadge(status) {
      return status === "A" ? "success" : status === "I" ? "secondary" : "";
    },
    getTextStatus(status) {
      return status === "A" ? "Activo" : status === "I" ? "Inactivo" : "";
    },
    addStaff() {
      this.$router.push({ path: `staffs/add` });
    },
    deleteStaff(id) {
      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar el registro!",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar"
      }).then(result => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(`${this.$urlApi}staffs/${id}?token=${this.token}`, {
              headers: { "Content-Type": "application/json" }
            })
            .then(function(response) {
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Registro eliminado correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar"
              }).then(result => {
                if (result.value) {
                  this.getStaffs(items => {
                    if (items) {
                      this.items = items;
                    }
                  });
                }
              });
            })
            .catch(error => {
              console.log(error);
              alert(error.body.error);
              hideLoader();
            });
        }
      });
    },
    editStaff(id) {
      this.$router.push({ path: `staffs/edit/${id.toString()}` });
    }
  }
};
</script>
